import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgIconsModule } from "@ng-icons/core";

// Consolidated grouped heroicon imports moved to hero-icon-groups.ts for maintainability.
import { ALL_HERO_ICON_GROUPS } from "./hero-icon-groups";
import { TABLER_CHART_ICONS } from "./tabler-icons-groups";
import { BOOTSTRAP_CHART_ICONS } from "./bootstrap-icons-group";

@NgModule({
  imports: [
    CommonModule,
    // Merge hero icon groups with custom Tabler chart icon set definitions.
    NgIconsModule.withIcons({
      ...ALL_HERO_ICON_GROUPS,
      ...TABLER_CHART_ICONS,
      ...BOOTSTRAP_CHART_ICONS,
    }),
  ],
  exports: [NgIconsModule],
})
export class HeroIconModule {}
